var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDestinationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 9,
    transform: "rotate(-180 9 9.5)",
    fill: "#2C358A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8418 4.0332C10.0353 4.0332 11.1799 4.50731 12.0238 5.35122C12.8677 6.19514 13.3418 7.33973 13.3418 8.5332C13.3418 10.4347 12.0056 12.507 9.36795 14.7723C9.22128 14.8983 9.03429 14.9675 8.84093 14.9673C8.64758 14.9671 8.4607 14.8976 8.31426 14.7714L8.1398 14.62C5.61887 12.4138 4.3418 10.3923 4.3418 8.5332C4.3418 7.33973 4.8159 6.19514 5.65982 5.35122C6.50373 4.50731 7.64832 4.0332 8.8418 4.0332ZM8.8418 6.80243C8.38277 6.80243 7.94254 6.98478 7.61796 7.30936C7.29338 7.63395 7.11103 8.07417 7.11103 8.5332C7.11103 8.99223 7.29338 9.43246 7.61796 9.75704C7.94254 10.0816 8.38277 10.264 8.8418 10.264C9.30083 10.264 9.74105 10.0816 10.0656 9.75704C10.3902 9.43246 10.5726 8.99223 10.5726 8.5332C10.5726 8.07417 10.3902 7.63395 10.0656 7.30936C9.74105 6.98478 9.30083 6.80243 8.8418 6.80243Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationicon);
export default __webpack_public_path__ + "static/media/destinationicon.59b81405f43327b4c83f6840c5a4a15d.svg";
export { ForwardRef as ReactComponent };